import React from 'react'

import Card from '@/components/card/card'
import TextElement from '@/components/text-element/text-element'
import { toReactNode } from '@/utils/react'

import { useSiteMetadata } from '../root-element'
import * as styles from './related.module.scss'

type RelatedProps = {
  related: readonly Card[]
  title?: string
}

const Related = ({
  related,
  title
}: Readonly<RelatedProps>): React.ReactElement => {
  const { settings } = useSiteMetadata()
  const titleDefault = toReactNode(settings['title-related-content'])
  if (related.length === 0) return <></>
  return (
    <section className={styles.relatedcontent}>
      <div className="container">
        <div className="row">
          <div className="col">
            <TextElement type="h2" text={title ?? titleDefault} />
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row d-flex mt-3">
          {related.map((item, index) => {
            if (item === null) return null
            return (
              <div className="col-lg-4 col-md-6 mb-4" key={index}>
                <Card item={item} />
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Related
